import { usesDyedUndyedAlpha } from '../../../../../shared/offer-domain/constants';
import { hasCounterOffer } from '../../../components/ModelDelivery/shared/utils';
import { getRowKey } from '../shared';

const applyCounterAlphaState = (updatedItem, item, value, rowKey) => {
  if (!hasCounterOffer(item) && getRowKey(item) !== rowKey) {
    return null;
  }
  updatedItem.counterAlpha = value;
  return updatedItem;
};

export default {
  isLpg: false,
  getUsesAlphaField: form => !usesDyedUndyedAlpha(form?.productNameId),
  getRequiresCargoRatio: () => false,
  requireIncotermCounter: false,
  isLpgCaseForLocations: false,
  shouldFetchPricingUnit: form => !usesDyedUndyedAlpha(form?.productNameId),
  preserveQuantityOnSave: false,
  getExpandKey: row => getRowKey(row),
  getGroupRowsForCounter: (_items, selectedRow) => [selectedRow],
  getAfterSaveExpandKey: row => getRowKey(row),
  applyCounterAlphaState,
  saveCargoRatioCounters: null,
  deleteCounterExtras: null,
  shouldDeleteSharedCounter: () => true,
  enrichOpenCounterModal: async ({ nextForm }) => nextForm,
  buildOriginalFormExtras: () => ({
    selectedRatios: [],
    sourceCargoRatios: [],
  }),
  enrichAfterFob: async ({ items }) => items,
  getCounterFormChangeOptions: () => ({
    isLpg: false,
    requiresCargoRatio: false,
  }),
  getValidateCounterOptions: () => ({
    requiresCargoRatio: false,
    skipLocationQuantity: false,
  }),
  usesDyedUndyedAlpha,
};
